import { Provider } from "react-redux";
import React from "react";
import ReactDom from "react-dom";
import { PersistGate } from "redux-persist/integration/react";
import { AppReducer, getAppServices } from "@10x/coreapp";
import { Store } from "redux";

/**
 * React Redux DOM Factory
 */
export default class HabitatFactory {
	store: Store<AppReducer>;

	constructor( store: Store<AppReducer> ) {

		/**
		 * The redux store
		 */
		this.store = store;
	}

	/**
	 * Inject the module into the dom wrapped in a redux provider
	 * @param {*} module - The component to inject
	 * @param {object} props  - The component props
	 * @param {node} target - The node to inject to
	 */
	inject( module: any, props = {}, target: any ) {
		if ( target ) {
			ReactDom.render( <Provider store={ this.store }>
					<PersistGate loading={ null } persistor={ getAppServices().storeService.getPersistor() }>
						{ React.createElement( module, props ) }
					</PersistGate>
				</Provider>
				, target );
		}
	}

	/**
	 * Dispose of any react instances for a node
	 * @param {node} target - The node to tear down
	 */
	dispose( target: any ) {
		if ( target ) {
			ReactDom.unmountComponentAtNode( target );
		}
	}
}
